import noImageCompany from '../../../../../../assets/images/emptyCompany.jpg';
import CardInfoManagement from '../../../../../layouts/Card/cardContent/CardInfoManagement';

export const listSettings = {
    grid : {
        components : CardInfoManagement,
        columns : {
            xs : 2,
            sm : 2,
            laptop : 2,
        }
    },
}

export const listMappers = [
    {
        view : 'card',
        mapper : null
    },
    // {
    //     view : 'table',
    //     mapper : 'companiesListMapper'
    // }
]

export const perPageOptions = {
    'card' : [6],
}